// API base URL - defaults to localhost, can be overridden with environment variable
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export default API_BASE_URL;

